<template>
  <div class="title">
    <div class="text">{{text}}</div>
    <div class="engText">{{engText}}</div>
  </div>
</template>

<script>

export default {
  props:['text','engText'],
  mounted () {
  }
}
</script>

<style scoped>
.title{
  height: 32px;
  background:url('@/assets/img/titlebgc.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  padding:0px 0px 5px 20px;
  overflow: hidden; /*溢出隐藏*/
      text-overflow: ellipsis;/*超出省略号显示*/
      white-space: nowrap;/*文字不换行 */
      position: relative;
}
.text{
  font-size: 15px;
  font-weight: 700;
  color: white;
}
.engText{
  font-size: 12px;
  color: #ccc;
  overflow:hidden;
    white-space: nowrap;
    text-overflow: ellipsis;  
}
</style>